var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-info-title",class:{ 'is-center': _vm.isCenter }},[_c('div',{staticClass:"game-info-title-text"},[_c('div',{staticClass:"title-area"},[_c('p',[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"game-info-title-extra"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }